export default "__VITE_ASSET__D$Hxz4UP__"